module.exports = __webpack_public_path__ + "media/photo/Component 22 – 1-aac46efa.jpg";